class RandomizerUtil {
  //returns a randon number from 1 to n
  //   static getRandomNumberFromN = (n: any) => {
  //     return Math.floor(Math.random() * n) + 1
  //   }

  //   //return an array of size n with randomized ints randomized
  //   static getRandomArray = (n: any) => {
  //     return Array.from({ length: n }, () => Math.floor(Math.random() * n))
  //   }

  //pass in an array will return array of n random items selected
  static getRandomItemsFromArray = (arr: any, n: any) => {
    var result = new Array(n),
      len = arr.length,
      taken = new Array(len)
    if (n > len) throw new RangeError('getRandom: more elements taken than available')
    while (n--) {
      var x = Math.floor(Math.random() * len)
      result[n] = arr[x in taken ? taken[x] : x]
      taken[x] = --len in taken ? taken[len] : len
    }
    return result
  }

  //pass in an array will suffle the array using the Fisher-Yates (aka Knuth) Shuffle method and return n items from the begining
  //   static shuffle = (arr: any, n: any) => {
  //     var currentIndex = arr.length,
  //       temporaryValue,
  //       randomIndex

  //     // While there remain elements to shuffle...
  //     while (0 !== currentIndex) {
  //       // Pick a remaining element...
  //       randomIndex = Math.floor(Math.random() * currentIndex)
  //       currentIndex -= 1

  //       // And swap it with the current element.
  //       temporaryValue = arr[currentIndex]
  //       arr[currentIndex] = arr[randomIndex]
  //       arr[randomIndex] = temporaryValue
  //     }

  //     return arr.slice(0, n)
  //   }
}

export default RandomizerUtil
